import React from "react";
import { useNavigate } from "react-router-dom";
import { BarChart3, CalendarSync, Check, Globe2, Lock, Receipt, Sparkles } from "lucide-react";

const PERKS = [
  [CalendarSync, "Synchronisation iCal Airbnb, Booking, Abritel"],
  [Globe2, "Réservation directe sans commission, paiement et caution en ligne"],
  [Sparkles, "Ménage automatique à chaque départ"],
  [Receipt, "Taxe de séjour calculée et déclarée"],
  [BarChart3, "Rapports mensuels et prix dynamiques"],
];
const BARS = [[8, 30, "bg-rose-300"], [42, 22, "bg-sky-300"], [70, 18, "bg-emerald-300"], [12, 40, "bg-amber-300"], [58, 30, "bg-rose-300"], [20, 25, "bg-sky-300"]];

function FakeDashboard() {
  return (
    <div className="space-y-4 select-none pointer-events-none" aria-hidden="true">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
        {[["Revenu du mois", "3 480 €"], ["Occupation", "78 %"], ["Arrivées 7 j", "5"], ["Note moyenne", "4,9/5"]].map(([l, v]) => (
          <div key={l} className="bg-white rounded-2xl border border-brand-soft p-4"><p className="text-xs text-brand-green/55">{l}</p><p className="font-display text-2xl font-semibold text-brand-greenDeep">{v}</p></div>
        ))}
      </div>
      <div className="bg-white rounded-2xl border border-brand-soft p-4 space-y-3">
        {BARS.map(([l, w, c], i) => <div key={i} className="h-6 bg-brand-softer rounded-lg relative"><div className={`absolute top-0 h-6 rounded-lg ${c}`} style={{ left: `${l}%`, width: `${w}%` }} /></div>)}
      </div>
      <div className="bg-white rounded-2xl border border-brand-soft p-4 space-y-2">
        {["Emma L. · Airbnb · 3 nuits · 420 €", "John S. · Booking · 5 nuits · 690 €", "Lucie M. · Direct · 2 nuits · 260 €"].map((t) => <div key={t} className="py-2 border-b border-brand-soft last:border-0 text-sm text-brand-greenDeep">{t}</div>)}
      </div>
    </div>
  );
}

export function StrLockedPreview() {
  const navigate = useNavigate();
  return (
    <div className="relative min-h-[70vh]" data-testid="str-locked-preview">
      <div className="blur-[6px] opacity-60"><FakeDashboard /></div>
      <div className="absolute inset-0 flex items-start justify-center pt-10 px-4">
        <div className="bg-white/95 backdrop-blur-xl rounded-3xl border border-brand-soft shadow-xl p-7 max-w-lg w-full">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-brand-lime/40 text-brand-greenDeep text-xs font-semibold"><Lock className="w-3.5 h-3.5" /> Premium & Pro</span>
          <h2 className="font-display text-3xl font-semibold text-brand-greenDeep mt-3">Location saisonnière</h2>
          <p className="text-sm text-brand-green/60 mt-1">Gérez vos locations courte durée au même endroit que vos locations longue durée.</p>
          <ul className="mt-5 space-y-2.5">
            {PERKS.map(([Icon, t]) => <li key={t} className="flex items-start gap-2.5 text-sm text-brand-greenDeep"><Icon className="w-4 h-4 mt-0.5 text-brand-limeDark shrink-0" />{t}</li>)}
          </ul>
          <p className="text-xs text-brand-green/50 mt-4 flex items-start gap-1.5"><Check className="w-3.5 h-3.5 mt-0.5 shrink-0" /> Vos données saisonnières déjà créées sont conservées et reprennent dès le passage à Premium ou Pro.</p>
          <button onClick={() => navigate("/app/profil")} className="mt-5 w-full py-3 rounded-full bg-brand-greenDeep text-white font-semibold hover:bg-brand-green transition-colors" data-testid="str-upgrade-btn">Passer à Premium</button>
        </div>
      </div>
    </div>
  );
}
